import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';

var ResponseWrapper = function () {
    function ResponseWrapper(response, error) {
        _classCallCheck(this, ResponseWrapper);

        this._response = response;
        this._error = error;
    }

    _createClass(ResponseWrapper, [{
        key: 'response',
        get: function get() {
            return this._response || /* istanbul ignore next: safeguard */{};
        }
    }, {
        key: 'error',
        get: function get() {
            return this._error;
        }
    }, {
        key: 'hasError',
        get: function get() {
            return !!this.error;
        }

        /* istanbul ignore next */

    }, {
        key: 'status',
        get: function get() {
            // eslint-disable-line class-methods-use-this
            throw new Error('Not implemented');
        }

        /* istanbul ignore next */

    }, {
        key: 'statusCode',
        get: function get() {
            // eslint-disable-line class-methods-use-this
            return this.status;
        }

        /* istanbul ignore next */

    }, {
        key: 'statusType',
        get: function get() {
            // eslint-disable-line class-methods-use-this
            throw new Error('Not implemented');
        }

        /* istanbul ignore next */

    }, {
        key: 'text',
        get: function get() {
            // eslint-disable-line class-methods-use-this
            throw new Error('Not implemented');
        }

        /* istanbul ignore next */

    }, {
        key: 'data',
        get: function get() {
            // eslint-disable-line class-methods-use-this
            throw new Error('Not implemented');
        }

        /* istanbul ignore next */

    }, {
        key: 'headers',
        get: function get() {
            // eslint-disable-line class-methods-use-this
            throw new Error('Not implemented');
        }
    }]);

    return ResponseWrapper;
}();

export default ResponseWrapper;


//////////////////
// WEBPACK FOOTER
// ../~/tg-resources/es/response.js
// module id = 1147
// module chunks = 0